<template>
    <div
        class="site footer"
        role="contentinfo"
    >
        <b-container class="text-center pt-3 pb-3">
            <content-item
                bundle-name="Footer"
                item-key="Footer">
            </content-item>
        </b-container>
    </div>
</template>

<script>
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
export default {
    name: 'FooterComponent',
    extends: PgbaBaseComponent
};
</script>